export default __webpack_public_path__ + "locales/nl/OAuth.json?hash=8c9e68b6cae59f7974030be4e5dd6db0";